"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseKeyParser = void 0;
const cryptography_1 = require("../../../cryptography");
const _1 = require(".");
/**
 * Base key-parser, provider features to read and convert keys in specific formats to hex value
 */
class BaseKeyParser {
    /**
     * Initialize the key-parser with a specific encryption type
     * @param encryptionType
     */
    constructor(encryptionType) {
        if (!encryptionType) {
            throw new Error("Encryption type is required");
        }
        this.encryptionType = encryptionType;
    }
    /**
     * Convert the given exported PEM as base64 to private-key as a hex byte-array
     * @param content
     * @returns
     */
    convertPEMToPrivateKey(content) {
        return this.convertPEMToKey(content);
    }
    /**
     * Internally convert the PEM format to hex data
     * @param content
     * @returns
     */
    convertPEMToKey(content) {
        const data = cryptography_1.EncoderUtils.readBase64PEM(content);
        return new _1.KeyValue(this.parsePrivateKey(data), this.encryptionType);
    }
}
exports.BaseKeyParser = BaseKeyParser;
